import { servicesUsers } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import {
    TUserEkycSetResponse,
    TUser_e_kyc_setParams,
} from 'types/entities/users';
import { TQueryDefWrapper } from 'types/network';

const useUsersEkycSet = (
    arg0?: TAsyncStatesHandlers<TQueryDefWrapper<TUserEkycSetResponse>, string>,
) => {
    return useMutationHookWrapper<
        TQueryDefWrapper<TUserEkycSetResponse>,
        string,
        { id: string; params: TUser_e_kyc_setParams }
    >({
        mutationFn: servicesUsers.e_kyc_set,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useUsersEkycSet;
